export interface SocialLink {
    platform: string
    icon: string
    url: string
}

export interface ContactInfo {
    address: string
    phone: string
    email: string
    socials: SocialLink[]
}

export const useContact = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const contactInfo = useState<ContactInfo>('school-contact-info', () => ({
        address: '',
        phone: '',
        email: '',
        socials: []
    }))

    const fetchContactInfo = async () => {
        try {
            const data = await $fetch<any>(`${apiBase}/oxoweb/school/info`)
            if (data) {
                const raw = data

                // Ensure socials is an array and filter out empty URLs
                const validSocials = Array.isArray(raw.socials)
                    ? raw.socials.filter((s: any) => s.platform && s.url)
                    : []

                contactInfo.value = {
                    address: raw.street ? `${raw.street}, ${raw.postalCode} ${raw.city}` : (raw.address || ''),
                    phone: raw.phone || '',
                    email: raw.email || '',
                    socials: validSocials
                }
            }
        } catch (e) {
            console.error('Error fetching contact info:', e)
        }
    }

    const submitForm = async (formData: any) => {
        try {
            const result = await $fetch(`${apiBase}/oxoweb/contact`, {
                method: 'POST',
                body: formData
            })
            return { success: true, message: 'Message envoyé avec succès !' }
        } catch (error) {
            console.error('Submission error:', error)
            throw error;
        }
    }

    return {
        contactInfo,
        fetchContactInfo,
        submitForm
    }
}
